import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    marginTop: theme.spacing(4.125),
    textAlign: 'left',
  },
  productContainer: {
    marginBottom: theme.spacing(3),
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
  productTitle: {
    fontSize: '0.875rem',
    fontWeight: 600,
    paddingBottom: theme.spacing(0.5),
    color: theme.palette.primary.light,
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  productSection: {
    marginTop: theme.spacing(3),
  },
  dimensionContainer: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2, 2, 2, 2),
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1),
  },
  dimensionRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dimensionTitle: {
    fontSize: '0.875rem',
    fontWeight: 600,
    paddingBottom: theme.spacing(0.5),
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  dimensionDescription: {
    fontSize: '0.875rem',
    width: '35%',
    textAlign: 'left',
    ['@media (max-width: 600px)']: {
      fontSize: '0.75rem',
    },
  },
  dimensionLabelWidth: {
    width: '30%',
  },
  dimensionPrices: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    flex: 1,
    '& p': {
      marginRight: theme.spacing(0.5),
      width: '100px',
    },
  },
  dimensionHeaders: {
    padding: theme.spacing(2, 2, 1, 2),
    width: 'auto',
  },
  wordBreak: {
    wordBreak: 'break-all',
  },
  dataText: {
    fontSize: '14px',
    color: theme.palette.black.main,
    fontWeight: 600,
    textAlign: 'left',
    wordBreak: 'break-all',
  },
}))
